import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokolhapurcab() {



    const cardData = {

keyword: "Pune to Kolhapur Cab",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Kolhapur Cab services for families, pilgrims, business travelers, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are traveling for Mahalaxmi Temple darshan, business work, or leisure trips, Rising Cab Service ensures a hassle-free and enjoyable journey to Kolhapur.",

topPlaces: [
    {
        title: "Mahalaxmi Temple",
        description:
            "Mahalaxmi Temple in Kolhapur is one of the most sacred Shakti Peethas in India, dedicated to Goddess Mahalakshmi. It is a highly revered pilgrimage site attracting devotees throughout the year."
    },
    {
        title: "Rankala Lake",
        description:
            "Rankala Lake is a beautiful and peaceful lake in Kolhapur known for sunset views, boating, and evening walks. It is a popular relaxation spot for tourists and locals."
    },
    {
        title: "Panhala Fort",
        description:
            "Panhala Fort is a historic hill fort associated with Chhatrapati Shivaji Maharaj and Bajiprabhu Deshpande. It offers scenic views, historic gateways, and trekking opportunities."
    },
    {
        title: "Jyotiba Temple",
        description:
            "Jyotiba Temple is a famous hilltop temple near Kolhapur dedicated to Lord Jyotiba. It is especially crowded during the annual Yatra festival."
    },
    {
        title: "New Palace Museum",
        description:
            "New Palace Museum is a royal palace showcasing artifacts, weapons, costumes, and history of the Kolhapur royal family, offering deep insight into Maratha heritage."
    },
    {
        title: "Shivaji University",
        description:
            "Shivaji University is a major educational institution in Kolhapur known for its vast campus, academic excellence, and research facilities."
    },
    {
        title: "Radhanagari Wildlife Sanctuary",
        description:
            "Radhanagari Wildlife Sanctuary is a rich biodiversity zone near Kolhapur known for wildlife, dense forests, and scenic natural beauty."
    },
    {
        title: "Gaganbawda",
        description:
            "Gaganbawda is a scenic hill station near Kolhapur known for misty valleys, waterfalls, and cool climate, making it a popular weekend getaway."
    },
    {
        title: "Shahu Maharaj Samadhi",
        description:
            "The Samadhi of Chhatrapati Shahu Maharaj is an important historical site reflecting Kolhapur’s royal heritage and legacy."
    },
    {
        title: "Kaneri Math",
        description:
            "Kaneri Math is a spiritual and cultural center known for its peaceful environment, ancient traditions, and religious importance in Kolhapur."
    }
],



services: [
    {
        name: "Pune to Kolhapur Cab",
        description:
            "Rising Cab Service offers Pune to Kolhapur Cab for safe, comfortable, and reliable intercity travel. This service is ideal for family trips, business travel, pilgrimage visits, and weekend tours. We provide well-maintained AC vehicles including sedans, SUVs, Innova, and Innova Crysta with professional drivers experienced in highway routes. Customers can choose one-way or round-trip options with door-to-door pickup and drop service. Whether you are visiting Kolhapur Mahalaxmi Temple, Jyotiba Temple, or planning a sightseeing trip, we ensure a smooth, punctual, and stress-free journey with transparent pricing and 24x7 booking support."
    },
    {
        name: "Pune to Kolhapur Taxi",
        description:
            "Book Pune to Kolhapur Taxi with Rising Cab Service for affordable and comfortable long-distance travel. Our taxis are ideal for solo passengers, families, and groups looking for safe highway journeys with experienced chauffeurs and clean vehicles."
    },
    {
        name: "Cab from Pune to Kolhapur",
        description:
            "Rising Cab Service provides Cab from Pune to Kolhapur with flexible pickup options, AC vehicles, and reliable drivers ensuring safe and timely intercity travel."
    },
    {
        name: "Taxi from Pune to Kolhapur",
        description:
            "Our Taxi from Pune to Kolhapur service ensures smooth highway travel with professional drivers, comfortable seating, and affordable pricing for all types of passengers."
    },
    {
        name: "Pune to Kolhapur Cab Service",
        description:
            "Rising Cab Service offers Pune to Kolhapur Cab Service with easy booking, clean vehicles, and dependable transportation for families, tourists, and business travelers."
    },
    {
        name: "Pune to Kolhapur Taxi Fare",
        description:
            "Get affordable Pune to Kolhapur Taxi Fare with transparent pricing, no hidden charges, and budget-friendly travel options for all customers."
    },
    {
        name: "Pune to Kolhapur One Way Cab",
        description:
            "Book Pune to Kolhapur One Way Cab for economical single-trip travel with professional drivers and comfortable vehicles."
    },
    {
        name: "Pune to Kolhapur Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Kolhapur Round Trip Taxi with flexible return timing, waiting options, and customized travel plans."
    },
    {
        name: "Pune to Kolhapur Cab Booking",
        description:
            "Our Pune to Kolhapur Cab Booking service offers instant confirmation, multiple vehicle choices, and 24x7 customer support for smooth travel planning."
    },
    {
        name: "Cheap Pune to Kolhapur Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Kolhapur Cab with economical fares while ensuring safe and comfortable intercity travel."
    },
    {
        name: "Best Pune to Kolhapur Taxi",
        description:
            "Choose the Best Pune to Kolhapur Taxi with Rising Cab Service for premium comfort, reliable drivers, and hassle-free travel experience."
    },
    {
        name: "Sedan Pune to Kolhapur Cab",
        description:
            "Our Sedan Pune to Kolhapur Cab service is perfect for individuals and small families seeking affordable and comfortable travel."
    },
    {
        name: "SUV Pune to Kolhapur Taxi",
        description:
            "Book SUV Pune to Kolhapur Taxi for spacious seating, extra luggage space, and smooth group travel on highways."
    },
    {
        name: "Innova Pune to Kolhapur Cab",
        description:
            "Rising Cab Service offers Innova Pune to Kolhapur Cab for family trips and group travel with premium comfort and spacious interiors."
    },
    {
        name: "Highway Cab Pune Kolhapur",
        description:
            "Our Highway Cab Pune Kolhapur service ensures safe and fast intercity travel with experienced drivers familiar with highway routes and traffic conditions."
    },
    {
        name: "Pune to Kolhapur Darshan Cab",
        description:
            "Book Pune to Kolhapur Darshan Cab for temple visits including Mahalaxmi Temple and Jyotiba Temple with comfortable and flexible travel options."
    },
    {
        name: "Kolhapur Darshan Taxi from Pune",
        description:
            "Rising Cab Service provides Kolhapur Darshan Taxi from Pune for religious and sightseeing tours with professional drivers and planned itineraries."
    },
    {
        name: "Pune to Mahalaxmi Temple Kolhapur Cab",
        description:
            "Our Pune to Mahalaxmi Temple Kolhapur Cab service offers safe pilgrimage travel with door-to-door pickup and comfortable AC vehicles."
    },
    {
        name: "Kolhapur Temple Tour Package from Pune",
        description:
            "Book Kolhapur Temple Tour Package from Pune for complete pilgrimage tours covering Mahalaxmi and Jyotiba temples with flexible schedules."
    },
    {
        name: "Pune to Jyotiba Darshan Cab",
        description:
            "Rising Cab Service provides Pune to Jyotiba Darshan Cab for smooth and comfortable temple travel with experienced drivers."
    },
    {
        name: "Pune to Kolhapur Religious Tour Cab",
        description:
            "Our Pune to Kolhapur Religious Tour Cab service is designed for devotees visiting sacred temples with safe and reliable transportation."
    },
    {
        name: "Kolhapur Sightseeing Cab from Pune",
        description:
            "Book Kolhapur Sightseeing Cab from Pune for exploring local attractions with flexible travel plans and comfortable vehicles."
    },
    {
        name: "Pune to Kolhapur Family Tour Taxi",
        description:
            "Rising Cab Service offers Pune to Kolhapur Family Tour Taxi with safe, spacious, and comfortable travel options for families."
    },
    {
        name: "Pune to Kolhapur Pilgrimage Cab",
        description:
            "Our Pune to Kolhapur Pilgrimage Cab service ensures smooth and peaceful travel for religious journeys and temple visits."
    },
    {
        name: "Pune to Kolhapur Tour Package Cab",
        description:
            "Book Pune to Kolhapur Tour Package Cab for customized travel plans covering temples, sightseeing, and family trips."
    },
    {
        name: "Pune Kolhapur Taxi",
        description:
            "Rising Cab Service provides Pune Kolhapur Taxi with reliable drivers, clean vehicles, and affordable pricing for all passengers."
    },
    {
        name: "Kolhapur Darshan Cab",
        description:
            "Book Kolhapur Darshan Cab for comfortable temple tours with flexible timings and professional chauffeurs."
    },
    {
        name: "Pune to Mahalaxmi Temple Taxi",
        description:
            "Our Pune to Mahalaxmi Temple Taxi service ensures safe pilgrimage travel with convenient pickup and drop facilities."
    },
    {
        name: "Pune to Jyotiba Cab",
        description:
            "Rising Cab Service offers Pune to Jyotiba Cab for smooth and reliable temple travel with experienced drivers."
    }
],
tableData: [
    ["Pune to Kolhapur Cab", "Pune to Kolhapur Taxi"],
    ["Cab from Pune to Kolhapur", "Taxi from Pune to Kolhapur"],
    ["Pune to Kolhapur One Way Cab", "Pune to Kolhapur Round Trip Taxi"],
    ["Pune to Kolhapur Cab Service", "Pune to Kolhapur Taxi Fare"],
    ["Cheap Pune to Kolhapur Cab", "Best Pune to Kolhapur Taxi"],
    ["Sedan Pune to Kolhapur Cab", "SUV Pune to Kolhapur Taxi"],
    ["Innova Pune to Kolhapur Cab", "Highway Cab Pune Kolhapur"],
    ["Pune to Kolhapur Darshan Cab", "Kolhapur Darshan Taxi from Pune"],
    ["Pune to Mahalaxmi Temple Cab", "Kolhapur Temple Tour Package from Pune"],
    ["Pune to Jyotiba Darshan Cab", "Pune Kolhapur Taxi"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Kolhapur Cab Service",
        WhyChoosedescription: "Rising Cab Service offers reliable Pune to Kolhapur cab transportation for families, business travelers, pilgrims, tourists, and students seeking a comfortable intercity journey."
    },
    {
        WhyChooseheading: "Perfect for Temple Visits and Tourism",
        WhyChoosedescription: "Travel conveniently to Mahalaxmi Temple, Panhala Fort, Jyotiba Temple, Rankala Lake, New Palace Museum, and other popular attractions in Kolhapur."
    },
    {
        WhyChooseheading: "Travel According to Your Schedule",
        WhyChoosedescription: "Choose from one-way transfers, same-day return trips, weekend tours, or multi-day travel plans based on your convenience."
    },
    {
        WhyChooseheading: "Vehicle Options for Every Travel Requirement",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for solo travelers, families, and groups."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune City",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and all major Pune locations."
    },
    {
        WhyChooseheading: "Smooth Highway Travel Experience",
        WhyChoosedescription: "Our experienced drivers ensure safe driving and a comfortable journey through major highways connecting Pune and Kolhapur."
    },
    {
        WhyChooseheading: "Suitable for Business and Family Travel",
        WhyChoosedescription: "Whether visiting Kolhapur for official work, family functions, religious purposes, or vacations, we provide convenient transportation solutions."
    },
    {
        WhyChooseheading: "Customized Travel and Sightseeing Plans",
        WhyChoosedescription: "Travelers can include temple visits, tourist attractions, meal stops, and nearby destinations as part of their itinerary."
    }
]
};

const faqData = [
    {
        question: "Which tourist attractions can be visited during a Pune to Kolhapur trip?",
        answer: "Popular attractions include Mahalaxmi Temple, Panhala Fort, Jyotiba Temple, Rankala Lake, New Palace Museum, and Siddhagiri Gramjivan Museum."
    },
    {
        question: "Is one-way transportation available between Pune and Kolhapur?",
        answer: "Yes, customers can choose one-way cab services as well as round-trip travel options."
    },
    {
        question: "Can devotees book cabs for Mahalaxmi Temple Darshan?",
        answer: "Yes, many travelers use our service specifically for Kolhapur Mahalaxmi Temple visits and religious tours."
    },
    {
        question: "Which vehicle category is most suitable for family travel?",
        answer: "Ertiga and Innova Crysta are frequently preferred by families because of their spacious seating and comfort."
    },
    {
        question: "Do you provide Tempo Travellers for group trips?",
        answer: "Yes, Tempo Travellers and larger group vehicles can be arranged for tours, pilgrimages, and family gatherings."
    },
    {
        question: "Can travelers include Panhala Fort in their itinerary?",
        answer: "Yes, customized travel plans can include Panhala Fort and other sightseeing destinations around Kolhapur."
    },
    {
        question: "Is same-day return travel possible from Pune to Kolhapur?",
        answer: "Yes, same-day return packages can be arranged depending on the customer's travel schedule."
    },
    {
        question: "Can corporate travelers use Pune to Kolhapur cab services?",
        answer: "Yes, business professionals regularly use our service for meetings, industrial visits, and official travel."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, customers can start their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I book a Pune to Kolhapur Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sachin Patole",
        feedback:
            "The Kolhapur temple visit was planned beautifully. The cab was comfortable, the travel timing was perfect, and we covered all the important places without any hassle.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Megha Shirole",
        feedback:
            "For our family trip to Kolhapur, Rising Cab Service provided a wonderful travel experience. The vehicle was spacious, and the journey remained pleasant throughout the day.",
        rating: 5
    }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Kolhapur Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-kolhapur-cab.jpg",
"description": "Book Pune to Kolhapur Cab Service with Rising Cab Service for safe and comfortable outstation travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and family-friendly vehicles.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-kolhapur-cab"
}
};





    return (
        <div>
<Helmet>
  <title>Pune to Kolhapur Cab Service | One Way & Round Trip Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Kolhapur Cab Service for safe and affordable outstation travel. Get reliable one-way and round-trip taxi service with sedan and SUV options for family and group trips."
/>

<meta
 name="keywords"
 content="pune to kolhapur cab, pune to kolhapur taxi, cab from pune to kolhapur, taxi from pune to kolhapur, pune to kolhapur cab service, pune to kolhapur taxi fare, pune to kolhapur one way cab, pune to kolhapur round trip taxi, pune to kolhapur cab booking, cheap pune to kolhapur cab, best pune to kolhapur taxi, sedan pune to kolhapur cab, suv pune to kolhapur cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/38.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokolhapurcab;